import { render, staticRenderFns } from "./serviceIframe.vue?vue&type=template&id=1da517d1&scoped=true"
import script from "./serviceIframe.vue?vue&type=script&lang=js"
export * from "./serviceIframe.vue?vue&type=script&lang=js"
import style0 from "./serviceIframe.vue?vue&type=style&index=0&id=1da517d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da517d1",
  null
  
)

export default component.exports